import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Users } from 'lucide-react';

const conferences = [
  {
    year: '2023',
    title: '1st Annual Africa Climate Finance Conference',
    theme: 'Financing Climate Action in Africa. Overcoming Barriers, Harnessing Opportunities',
    date: 'September 18-19, 2023',
    location: 'Kampala, Uganda'
  },
  {
    year: '2025',
    title: '2nd Annual Africa Climate Finance Conference',
    theme: 'Closing the Climate Financing Gap in Africa',
    date: 'April 1-2, 2025',
    location: 'Kampala, Uganda'
  }
];

export default function ConferenceTimeline() {
  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-gray-900">Conference History</h2>
          <p className="mt-4 text-lg text-gray-600">
            Our journey in advancing climate finance in Africa
          </p>
        </motion.div>

        <div className="relative">
          {/* Horizontal line */}
          <div className="absolute top-8 left-0 right-0 h-1 bg-gradient-to-r from-green-200 via-green-400 to-green-200 rounded-full" />
          
          <div className="flex justify-around items-start relative pt-16">
            {conferences.map((conference, index) => (
              <motion.div
                key={conference.year}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                viewport={{ once: true }}
                className="relative w-[calc(50%-2rem)]"
              >
                {/* Year bubble with glow effect */}
                <div className="absolute -top-24 left-1/2 transform -translate-x-1/2 w-16 h-16 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center text-white font-bold z-10 shadow-lg shadow-green-200">
                  <div className="absolute inset-0 bg-green-400 rounded-full animate-pulse opacity-20" />
                  {conference.year}
                </div>

                {/* Content box */}
                <motion.div
                  whileHover={{ scale: 1.02 }}
                  className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all border border-green-100"
                >
                  {/* Title */}
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{conference.title}</h3>
                  
                  <div className="space-y-3">
                    {/* Theme */}
                    <div className="flex items-center text-gray-600 text-sm gap-2">
                      <Users className="h-4 w-4 text-green-500" />
                      <span className="font-medium">Theme:</span> {conference.theme}
                    </div>
                    {/* Date */}
                    <div className="flex items-center text-gray-600 text-sm gap-2">
                      <Calendar className="h-4 w-4 text-green-500" />
                      {conference.date}
                    </div>
                    {/* Location */}
                    <div className="flex items-center text-gray-600 text-sm gap-2">
                      <MapPin className="h-4 w-4 text-green-500" />
                      {conference.location}
                    </div>
                  </div>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}